import { useQuery } from '@tanstack/react-query'
import { siteContextQuery } from '@/features/site/context'
import { useAuth } from './useAuth'

/**
 * Whether the school works with guardians (parents). Schools can turn them off (school settings):
 * then only students use the portal, which is called the student portal. Before sign-in, the school
 * comes from the address; with no school known (single-address mode) guardians are assumed.
 */
export function useGuardians(): boolean {
  const { school } = useAuth()
  const site = useQuery({ ...siteContextQuery(), enabled: school === null })
  return (school ?? site.data?.school ?? null)?.guardiansEnabled !== false
}

/** "Family portal" or, without guardians, "Student portal" (English source text, to translate). */
export function familyPortalLabel(guardians: boolean): string {
  return guardians ? 'Family portal' : 'Student portal'
}
